import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

interface RoleProtectedRouteProps {
  allowedRoles: number[];
  userRoleId: number;
}

const RoleProtectedRoute: React.FC<RoleProtectedRouteProps> = ({ allowedRoles, userRoleId }) => {
  return allowedRoles.includes(userRoleId) ? <Outlet /> : <Navigate to="/unauthorized" replace />;
};

export default RoleProtectedRoute;
